import { TypeSelector as BaseTypeSelector } from '@tabeo/scarf'
import React, { useCallback } from 'react'
import { get, load } from '../../../resources/Ticket/types'

function TypeSelector({ ...rest }) {
  const fetchTags = useCallback(load, [])

  const { value, onChange } = rest.input

  return (
    <BaseTypeSelector
      label="Type"
      name="type"
      loadOptions={fetchTags}
      {...rest}
      value={
        value === 'default' || !value ? null : { value, label: get(value) }
      }
      onChange={e => onChange(e?.value)}
    />
  )
}

export default TypeSelector
